import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from 'react-redux';

import {
  AddButton,
  Buttons,
  CancelButton,
  UpdateButton,
} from '../../components/Common/iComponents/iPopUp/IpopUp';

import { getEntitiesByType } from '../../store/actions';
import { ISelector } from '../../components/Common/iComponents/iSelector/iSelector';

const FormUsers = ({
  selectedEntities,
  onCreateUser,
  onUpdateUser,
  onCancel,
}: any) => {
  const dispatch = useDispatch();

  const { GetEntitiesByType } = useSelector(
    (state: any) => state.Entities.data,
  );

  const [entitiesState, setEntitiesState] = useState<any>([
    {
      id: '',
      name: '',
    },
  ]);


  useEffect(() => {
    if (!GetEntitiesByType) dispatch(getEntitiesByType());
  }, []);

  useEffect(() => {
    if (selectedEntities && Array.isArray(selectedEntities)) {

      const newArray = selectedEntities.map( (item:any) => {
        const id = GetEntitiesByType?.find( (itemFilter:any) => itemFilter.name.toLowerCase().trim() === item.value.toLowerCase().trim())?.id
        return{
          id,
          name: item.label
        }
      })
      setEntitiesState( newArray )
    }
  }, [selectedEntities, GetEntitiesByType]);
  const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
  const [paginationRoles, setPaginationRoles] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });

  const handlePaginationRolesChange = (newState: any) => {
    setPaginationRoles(newState);
  };

  const initialArrayTableEntities = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, entity: any) => <>{entity.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, entity: any) => <>{entity.name}</>,
      hidden: false,
    },
  ];

  const onChangeHandler = (e: any, index: any) => {
    const newArray = [...entitiesState];
    let object;
    if (typeof e === 'string') {
      const name = GetEntitiesByType.filter(
        (itemEntity: any) => Number(itemEntity.id) === Number(e),
      )[0]?.name;
      object = { ...newArray[index], id: e, name: name ?? '' };
      newArray[index] = object;
    } else {
      object = { id: e.id, name: e.name };
      newArray[index] = object;
    }
    setEntitiesState(newArray);
  };

  const renderButtons = () => (
    <Buttons>
      <>
        <CancelButton
          className="btn-delete"
          onClick={() => onCancel()}
          data-bs-toggle="tooltip"
        >
          <i
            className="bx bx-user-x bx-flashing-hover"
            style={{ fontSize: '2.5em' }}
            data-bs-toggle="tooltip"
          ></i>
        </CancelButton>
        <UpdateButton
          className="button "
          onClick={() => {
            let text = '';
            text = '["';
            text =
              text +
              entitiesState.map((item: any) => item.name.trim()).join('","');
            text = text + '"]';
            onUpdateUser(text);
          }}
        >
          <i
            className="bx bx-user-check bx-tada-hover"
            style={{ fontSize: '2.5em' }}
          ></i>
        </UpdateButton>
      </>
    </Buttons>
  );

  return (
    <>
      <div
        className="row justify-content-center"
        style={{ height: '450px', maxWidth: '100%', overflow: 'auto' }}
      >
        {entitiesState.map((item: any, index: number) => {
          const { name, id } = item;
          return (
            <>
              <div className="col-8 pt-3">
                <ISelector
                  title={`Entity${' - ' + (Number(index) + 1)}`}
                  value={String(id)}
                  nameSelector={name}
                  valuesSizePagination={valuesSizeRolesPagination}
                  dataSelector={GetEntitiesByType}
                  initialArrayTable={initialArrayTableEntities}
                  handlePaginationChange={handlePaginationRolesChange}
                  setSelectedRow={(title, row) => {
                    onChangeHandler(row, index);
                  }}
                  onChangeHandler={(e, title) =>
                    onChangeHandler(e.target.value, index)
                  }
                />
              </div>
              <div className="col-2 pt-3 mt-1">
                <CancelButton
                  className="btn-delete"
                  onClick={() => {
                    if (entitiesState.length === 1) return;
                    const newArray = [...entitiesState];
                    newArray.splice(index, 1);
                    setEntitiesState(newArray);
                  }}
                  data-bs-toggle="tooltip"
                >
                  <i
                    className="bx bx-trash bx-flashing-hover"
                    style={{ fontSize: '2em' }}
                    data-bs-toggle="tooltip"
                  ></i>
                </CancelButton>
              </div>
            </>
          );
        })}
        <div className="col-4 pt-2 mb-2">
          <AddButton
            className="button"
            onClick={() => {
              const newArray = [...entitiesState];
              newArray.push({
                id: '',
                name: '',
              });
              setEntitiesState(newArray);
            }}
          >
            Add Entity
          </AddButton>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1%',
          marginRight: '1%',
        }}
      >
        {renderButtons()}
      </div>
    </>
  );
};

FormUsers.propTypes = {
  selectedEntities: PropTypes.string,
  onCreateUser: PropTypes.func,
  onUpdateUser: PropTypes.func,
  onDeleteUser: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormUsers;
